import React, { useEffect, useState } from 'react';
import Product from '../Product/Product';
import axios from 'axios';
import { useQuery } from 'react-query';
import Pagination from "react-js-pagination";

export default function Products() {
  const [activePage, setActivePage] = useState(1)
  const [Products, setProducts] = useState([])
  const [results, setResults] = useState(1)
  const [metadata, setMetadata] = useState({})

  const [Isloading, setIsloading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('');

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  function handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    setActivePage(pageNumber)
    GetAllProducts(pageNumber)
  }
  async function GetAllProducts(pageNumber) {
    setIsloading(true);
    let { data } = await axios.get('https://ecommerce.routemisr.com/api/v1/products?page=' + pageNumber);
    setProducts(data.data);
    setResults(data.results)
    setMetadata(data.metadata)
    setIsloading(false);

  }
  useEffect(() => {
    GetAllProducts(1);
  }, []);


  const filteredProducts = Products.filter(product =>
    product.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container">
      {Isloading ? (
        <div className="d-flex align-items-center justify-content-center my-5 py-5 text-center loader-row">
          <div className="col-auto">
            <div className ="preloader">
              <svg className ="cart" role="img" aria-label="Shopping cart line animation" viewBox="0 0 128 128" width="128px" height="128px" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="8">
                  <g className ="cart__track" stroke="hsla(0,10%,10%,0.1)">
                    <polyline points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" />
                    <circle cx="43" cy="111" r="13" />
                    <circle cx="102" cy="111" r="13" />
                  </g>
                  <g className ="cart__lines" stroke="currentColor">
                    <polyline className ="cart__top" points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80" stroke-dasharray="338 338" stroke-dashoffset="-338" />
                    <g className ="cart__wheel1" transform="rotate(-90,43,111)">
                      <circle className ="cart__wheel-stroke" cx="43" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
                    </g>
                    <g className ="cart__wheel2" transform="rotate(90,102,111)">
                      <circle className ="cart__wheel-stroke" cx="102" cy="111" r="13" stroke-dasharray="81.68 81.68" stroke-dashoffset="81.68" />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="row pt-5">
            <div className="row pb-1 justify-content-center">
              <input
                className="form-control search-input my-5 w-75"
                placeholder="Search ....."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            {filteredProducts.map((product, index) => (
              <div key={index} className="col-md-3">
                <Product product={product} />
              </div>
            ))}
          </div>
          <Pagination
            activePage={activePage}
            itemsCountPerPage={metadata.limit}
            totalItemsCount={results}
            pageRangeDisplayed={5}
            linkClassName="pagination-link"
            onChange={handlePageChange}
          />
        </>
      )}
    </div>
  );
}